{
  "pt": {
    "dashboard": {
      "greetings": {
        "afternoon": "Boa tarde {first_name}",
        "evening": "Boa noite {first_name}",
        "morning": "Bom dia {first_name}",
        "night": "Boa noite {first_name}"
      },
      "titles": {
        "activityFeed": "Feed de actividades",
        "assignedTasks": "As minhas tarefas",
        "newsFeed": "Feed de notícias",
        "ongoingTickets": "Em curso",
        "openTickets": "Aberto",
        "tickets": "Conversas",
        "totalTickets": "Todos",
        "unreadTickets": "Não lido",
        "yourAssignedTickets": "As conversas que lhe foram atribuídas"
      }
    }
  }
}
